import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom'; // 导入 Router
import '@/styles/index.css'; // 引入 Tailwind
import App from './pages/App'; // 引入根组件


// 确保 root 节点存在于 index.html 中
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Router>
        <App /> {/* 渲染根组件 */}
    </Router>
  </React.StrictMode>
);